module.exports = __webpack_public_path__ + "static/media/springGreen.e0903301.jpg";